module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f90ab1af.png";